import React from 'react';
import { useInView } from '@/hooks/useInView';

/**
 * Word-by-word reveal. Splits children string into words and animates each.
 * Use accent prop to highlight one word (string match) in violet.
 */
export function WordReveal({
  as: As = 'h1',
  text,
  className = '',
  accent,
  accentColor = '#6C5CE7',
  baseDelay = 0,
  perWordDelay = 70,
  'data-testid': testId,
}) {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const words = String(text).split(' ');

  return (
    <As
      ref={ref}
      data-testid={testId}
      className={`${className} ${inView ? 'in-view' : ''}`}
    >
      {words.map((w, i) => {
        const cleanWord = w.replace(/[^\w'-]/g, '').toLowerCase();
        const cleanAccent = accent ? accent.replace(/[^\w'-]/g, '').toLowerCase() : null;
        const isAccent = cleanAccent && cleanWord === cleanAccent;
        return (
          <span key={i} className="word" style={{ marginRight: '0.28em' }}>
            <span
              style={{
                transitionDelay: `${baseDelay + i * perWordDelay}ms`,
                color: isAccent ? accentColor : undefined,
                fontStyle: isAccent ? 'italic' : undefined,
              }}
            >
              {w}
            </span>
          </span>
        );
      })}
    </As>
  );
}
